import { render, staticRenderFns } from "./VerAdmision.vue?vue&type=template&id=0617c1ab"
import script from "./VerAdmision.vue?vue&type=script&lang=js"
export * from "./VerAdmision.vue?vue&type=script&lang=js"
import style0 from "./VerAdmision.vue?vue&type=style&index=0&id=0617c1ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports